/**
 * 防抖
 * @param {function} 执行函数
 * @param {number} delay 延时ms
 * debounce 用于全局 调用事件内使用
 * debounceFn 用于事件处理 将事件包裹
 */
let _debounceTimeout = null;
export const debounce = (fn, delay = 500) => {
  clearTimeout(_debounceTimeout);
  _debounceTimeout = setTimeout(() => {
    fn();
  }, delay);
}

export const debounceFn = (fn, t) => {
  let delay = t || 500;
  let timer;
  return function() {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, delay);
  }
};

/**
 * 节流
 * @param {function} 执行函数
 * @param {number} delay 延时ms
 * throttle 用于全局 调用事件内使用
 * throttleFn 用于事件处理 将事件包裹
 */
let _throttleRunning = false;
export const throttle = (fn, delay = 500) => {
  if (_throttleRunning) {
    return;
  }
  _throttleRunning = true;
  fn();
  setTimeout(() => {
    _throttleRunning = false;
  }, delay);
}

export const throttleFn = (fn, t, f = true) => {
  // f是否只首次执行
  let last;
  let timer;
  let interval = t || 500;
  return function() {
    let args = arguments;
    let now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        !f && fn.apply(this, args);
      }, interval);
    } else {
      last = now;
      fn.apply(this, args);
    }
  }
}


//base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
function dataURLto(dataurl, type) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  if (type === 'bold') {
    return new Blob([u8arr], {
      type: mime
    });
  } else {
    return new File([u8arr], {
      type: mime
    });
  }
};

//将bold文件转换bold路径的地址
function getObjectURL(file) {
  var url = null;
  if (window.createObjectURL !== undefined) { // basic
    url = window.createObjectURL(file);
  } else if (window.URL !== undefined) { // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL !== undefined) { // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  console.log(url)
  return url;
};

//压缩图片 limit 限制图片大小，多少下压缩
export const compressImg = (file, limit = 2) => {
  var src;
  var files;
  var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
  var read = new FileReader();
  read.readAsDataURL(file);
  return new Promise(function(resolve, reject) {
    read.onload = function(e) {
      var img = new Image();
      img.src = e.target.result;
      img.onload = function() {
        //默认按比例压缩
        var w = this.width,
          h = this.height;
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var base64;
        // 创建属性节点
        canvas.setAttribute("width", w);
        canvas.setAttribute("height", h);
        ctx.drawImage(this, 0, 0, w, h);
        var radio = 1; //压缩比例
        if (fileSize < limit) {
          // 小于限制 则使用原图
          resolve({
            file: file
          })
          return
        } else if (fileSize < 10) {
          radio = 0.8;
        } else if (fileSize < 20) {
          radio = 0.5;
        } else {
          radio = 0.3;
        }
        base64 = canvas.toDataURL(file['type'], radio);
        // 回调函数返回file的值（将base64编码转成file）
        files = {};
        files.url = getObjectURL(dataURLto(base64, 'file')); //如果后台接收类型为base64的话这一步可以省略
        files.file = dataURLto(base64, 'file')
        resolve(files)
      };
    };
  })
};

export const getUserIP = (onNewIP) => {
  let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
  let pc = new MyPeerConnection({
    iceServers: []
  });
  let noop = () => {};
  let localIPs = {};
  let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
  let iterateIP = (ip) => {
    if (!localIPs[ip]) onNewIP(ip);
    localIPs[ip] = true;
  };

  pc.createDataChannel('');
  pc.createOffer().then((sdp) => {

    sdp.sdp.split('\n').forEach(function(line) {
      if (line.indexOf('candidate') < 0) return;
      line.match(ipRegex).forEach(iterateIP);
    });
    pc.setLocalDescription(sdp, noop, noop);
  }).catch((reason) => {});
  pc.onicecandidate = (ice) => {

    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
    ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
  };
}



// WEBPACK FOOTER //
// ./src/assets/js/tool.js